import React, { memo } from 'react';
import moneyIcon from '../../assets/v4_img/money.png';

/**
 * 웰니스 돈 모양 아이콘 컴포넌트
 */
const WellnessMoneyIcon = memo(({ 
  onClick, 
  canClick, 
  isClicking, 
  dailyEarned, 
  maxDailyEarning,
  progressPercentage 
}) => {
  return (
          <div 
        className="wellness-money-icon-container"
        style={{
          position: 'fixed',
          top: '120px', // 95px → 120px로 늘림 (에그 카운터와의 마진 증가)
          right: '30px', // 약간 안쪽으로
          zIndex: 1000,
          animation: 'breathe 3s ease-in-out infinite'
        }}
      >
      <button
        className={`wellness-money-icon ${isClicking ? 'clicking' : ''} ${!canClick ? 'disabled' : ''}`}
        onClick={onClick}
        disabled={!canClick}
        style={{
          width: '55px',
          height: '55px',
          borderRadius: '50%',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          border: canClick ? '2px solid #4CC38A' : '2px solid #CCCCCC',
          cursor: canClick ? 'pointer' : 'not-allowed',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          boxShadow: canClick 
            ? '0 3px 10px rgba(76, 195, 138, 0.3)' 
            : '0 2px 6px rgba(0, 0, 0, 0.15)',
          transition: 'all 0.3s ease',
          transform: isClicking ? 'scale(0.9)' : 'scale(1)',
          animation: canClick ? 'moneyPulse 2s infinite' : 'none',
          position: 'relative',
          overflow: 'visible',
          backdropFilter: 'blur(10px)'
        }}
      >
        {/* money.png 아이콘 */}
        <img 
          src={moneyIcon} 
          alt="휴식 지원금" 
          style={{
            width: '38px',
            height: '38px',
            objectFit: 'contain',
            imageRendering: 'crisp-edges',
            filter: canClick ? 'none' : 'grayscale(100%)',
            opacity: canClick ? 1 : 0.6
          }}
        />

        {/* 진행률 표시 원형 바 */}
        {progressPercentage > 0 && (
          <div
            style={{
              position: 'absolute',
              top: '-2px',
              left: '-2px',
              width: '59px',
              height: '59px',
              borderRadius: '50%',
              background: progressPercentage >= 99.9 
                ? '#4CC38A' // 99.9% 이상일 때는 완전한 원형 (미세한 오차 방지)
                : `conic-gradient(
                    #4CC38A 0deg ${Math.min(progressPercentage * 3.6, 359.9)}deg,
                    transparent ${Math.min(progressPercentage * 3.6, 359.9)}deg 360deg
                  )`,
              zIndex: -1,
            }}
          />
        )}
      </button>

      {/* 수집 현황 표시 */}
      <div
        style={{
          position: 'absolute',
          top: '50px',
          left: '50%',
          transform: 'translateX(-50%)',
          backgroundColor: 'rgba(255, 255, 255, 0.95)',
          borderRadius: '10px',
          padding: '3px 7px',
          fontSize: '9px',
          fontWeight: '600',
          fontFamily: 'Pretendard',
          color: '#555',
          whiteSpace: 'nowrap',
          boxShadow: '0 2px 6px rgba(0, 0, 0, 0.08)',
          border: '1px solid rgba(255, 255, 255, 0.7)',
          backdropFilter: 'blur(5px)'
        }}
      >
행운의 복권 긁기
      </div>

      {/* CSS 애니메이션 */}
      <style>
        {`
          @keyframes breathe {
            0%, 100% {
              transform: scale(1);
            }
            50% {
              transform: scale(1.02);
            }
          }
          
          @keyframes moneyPulse {
            0%, 100% { 
              transform: scale(1);
              box-shadow: 0 4px 12px rgba(76, 195, 138, 0.4);
            }
            50% { 
              transform: scale(1.05);
              box-shadow: 0 6px 16px rgba(76, 195, 138, 0.6);
            }
          }

          .wellness-money-icon:hover:not(.disabled) {
            transform: scale(1.1) !important;
            box-shadow: 0 6px 16px rgba(76, 195, 138, 0.6) !important;
          }

          .wellness-money-icon.clicking {
            animation: none !important;
          }
        `}
      </style>
    </div>
  );
});

WellnessMoneyIcon.displayName = 'WellnessMoneyIcon';

export default WellnessMoneyIcon;
